import { DragHandleRule } from '@tiptap/extension-drag-handle';

/**
 * detailsSummary/detailsContent are never drag targets themselves
 */
const excludeDetailsChildren: DragHandleRule = {
  id: 'excludeDetailsChildren',
  evaluate: ({ node }) => {
    const excluded = ['detailsSummary', 'detailsContent'];
    return excluded.includes(node.type.name) ? 1000 : 0;
  },
};

/**
 * Nodes inside the summary are excluded so only the whole details block is draggable from there
 */
const excludeDetailsSummaryChildren: DragHandleRule = {
  id: 'excludeDetailsSummaryChildren',
  evaluate: ({ $pos, depth }) => {
    for (let d = depth - 1; d > 0; d--) {
      if ($pos.node(d).type.name === 'detailsSummary') {
        return 1000;
      }
    }
    return 0;
  },
};

/**
 * The details block is excluded when inside detailsContent so only child nodes are draggable
 */
const excludeDetailsWhenInsideContent: DragHandleRule = {
  id: 'excludeDetailsWhenInsideContent',
  evaluate: ({ node, $pos, depth }) => {
    if (node.type.name !== 'details') return 0;

    for (let d = $pos.depth; d > depth; d--) {
      if ($pos.node(d).type.name === 'detailsContent') {
        return 1000;
      }
    }

    return 0;
  },
};

export const DETAILS_DRAG_RULES: DragHandleRule[] = [
  excludeDetailsChildren,
  excludeDetailsSummaryChildren,
  excludeDetailsWhenInsideContent,
];
